module.exports = __webpack_public_path__ + "img/it.c78d3c3c.svg";